import { render, staticRenderFns } from "./edit-fields-definitions-form.vue?vue&type=template&id=3c212795"
import script from "./edit-fields-definitions-form.vue?vue&type=script&lang=js"
export * from "./edit-fields-definitions-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports